import React from 'react';

function ListingBadges({items = []}) {
    return (
        items.length > 0 && (
            <div className="ListingBadges__container">
                {items.map((item) => (
                    <span className="label label-default" key={item}>
                        {item}
                    </span>
                ))}
            </div>
        )
    );
}

export default React.memo(ListingBadges);
